import styled from 'styled-components'

export const Container = styled.div`
  height: 800px;
  @media (max-width: 575px) {
    margin-top: 24px;
  }
`

interface TableProps {
  size: string
}

export const Table = styled.table<TableProps>`
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  background: #fff;
  font-variant: tabular-nums;
  line-height: 1.5715;
  width: 100%;
  -webkit-overflow-scrolling: 'touch';
  position: relative;
  padding-top: ${(props) => (props.size === 'middle' ? '55px' : '0')};
`

interface HeaderRowProps {
  size: string
}

export const HeaderRow = styled.tr<HeaderRowProps>`
  > th {
    position: sticky;
    top: 0;
    padding: ;
    border-right: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    text-align: left;
    background: #fafafa;
    padding: ${(props) => (props.size === 'middle' ? '16px' : '8px')};
  }
`

export const StatusCell = styled.td`
  padding: 16px;
  width: 100%;
  text-align: center;
`

interface RowProps {
  active: boolean
  size: string
}

export const Row = styled.tr<RowProps>`
  background-color: ${(props) => (props.active ? '#e6f7ff' : 'inherit')};
  > td {
    padding: ${(props) => (props.size === 'middle' ? '16px' : '8px')};
  }
`

export const Cell = styled.td`
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
`
